import { marked } from 'marked'
import { sanitize } from 'isomorphic-dompurify'

export default defineNuxtPlugin(() => {
  function renderAndSanitize(input: string) {
    return sanitize(marked.parse(input, { async: false }), {
      USE_PROFILES: { html: true },
    })
  }

  return {
    provide: {
      md: renderAndSanitize,
    },
  }
})
